/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 2024d97cf5c0
 */

import * as z from "zod";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import {
  StreamingProfileUpdate,
  StreamingProfileUpdate$zodSchema,
} from "./streamingprofileupdate.js";
import {
  StreamingProfileUpdateResponse,
  StreamingProfileUpdateResponse$zodSchema,
} from "./streamingprofileupdateresponse.js";

export type UpdateStreamingProfileGlobals = { cloud_name?: string | undefined };

export const UpdateStreamingProfileGlobals$zodSchema: z.ZodType<
  UpdateStreamingProfileGlobals
> = z.object({
  cloud_name: z.string().describe("The cloud name of your product environment.")
    .optional(),
});

export type UpdateStreamingProfileRequest = {
  name: string;
  streaming_profile_update: StreamingProfileUpdate;
};

export const UpdateStreamingProfileRequest$zodSchema: z.ZodType<
  UpdateStreamingProfileRequest
> = z.object({
  name: z.string().describe("The name of the streaming profile."),
  streaming_profile_update: StreamingProfileUpdate$zodSchema.describe(
    "The updated streaming profile configuration.",
  ),
});

export type UpdateStreamingProfileResponse =
  | StreamingProfileUpdateResponse
  | ApiError;

export const UpdateStreamingProfileResponse$zodSchema: z.ZodType<
  UpdateStreamingProfileResponse
> = z.union([
  StreamingProfileUpdateResponse$zodSchema,
  ApiError$zodSchema,
]);
